module.exports = __webpack_public_path__ + "img/garde-frontiere.f5d60541.jpg";